export const QUERY_PAYMENTS_TAXFORM_PAYEE = "QUERY_PAYMENTS_TAXFORM_PAYEE";
export const QUERY_PAYMENTS_TAXFORM_PAYER = "QUERY_PAYMENTS_TAXFORM_PAYER";
export const QUERY_PAYMENTS_TAXFORM_LIST_PAYEE =
  "QUERY_PAYMENTS_TAXFORM_LIST_PAYEE";
export const QUERY_PAYMENTS_TAXFORM_LIST_PAYER =
  "QUERY_PAYMENTS_TAXFORM_LIST_PAYER";
export const QUERY_PAYMENTS_TAXFORM_WITH_CORRECTION_PAYER =
  "QUERY_PAYMENTS_TAXFORM_WITH_CORRECTION_PAYER";
